import type { StickyCardsProps } from "@op/puck-types";
import { default as StickyCard } from "../../../../../components/base/StickyCard/StickyCard";

const StickyCards = ({ items }: StickyCardsProps) => {
  return (
    <div className="flex flex-col gap-4 w-full">
      {items.map((item, idx) => (
        <StickyCard {...item} key={`${idx}`} idx={idx} />
      ))}
    </div>
  );
};

export default StickyCards;
